import { get } from 'lodash'
import React, { useCallback } from 'react'

import { ModalResetActivationCode } from 'components/ModalResetActivationCode'

import { useDisclosure } from '@chakra-ui/react'
import { FiXCircle } from 'react-icons/fi'

import { ActionProps } from './types'
import { WrapperAction } from './WrapperAction'

export const ResetActivationCodeAction = <T extends unknown>({
  record,
  options,
}: ActionProps<T>) => {
  const modalResetActivationCodeDisclosure = useDisclosure()

  const { callback, actionType = 'menu', reload, ...optionsRest } = options

  if (!reload) {
    throw new Error('reload is required')
  }

  const cta = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, data: T) => {
      modalResetActivationCodeDisclosure.onOpen()

      if (callback) {
        callback(e, data)
      }
    },
    [modalResetActivationCodeDisclosure, callback]
  )

  return (
    <>
      <ModalResetActivationCode
        reload={reload}
        activationCode={get(record, 'activationCode')}
        isOpen={modalResetActivationCodeDisclosure.isOpen}
        onCancel={modalResetActivationCodeDisclosure.onClose}
      />

      <WrapperAction
        cta={cta}
        record={record}
        icon={FiXCircle}
        options={optionsRest}
        actionType={actionType}
        label="Resetar ativação"
        tooltip="Para resetar o kit, é necessário ter a função de superadmin"
        tooltipProps={{
          shouldWrapChildren: true,
          isDisabled: !optionsRest.isDisabled,
        }}
      />
    </>
  )
}
